module.exports = __webpack_public_path__ + "static/media/sun-icon.cd7c11df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/sun-icon.svg
// module id = 3262
// module chunks = 0